import React, { useEffect, useState } from "react"
import Differentiator from "../components/Differentiator"
import Footer from "../components/Footer"
import ProfessionHerov4 from "../components/ProfessionHerov4"
import "../styles/321global.css"
import "../styles/professionpage3.css"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet"
import ReactHtmlParser from "react-html-parser"
import Session321 from "../components/Session321"
import SectionForV3 from "../components/SectionForV3"
import CoverageForV3 from "../components/CoverageForV3"

const ProfessionPage = data => {
  const [industryPageHero, setIndustryPageHero] = useState([])
  const [industryPageBody, setIndustryPageBody] = useState([])
  const [coverages, setCoverages] = useState([])
  const [pageHero, setPageHero] = useState(null)
  const [pageBody, setPageBody] = useState(null)

  // function swapDefaultText() {
  //   if (data.data.butterPage.paragraph_one) {
  //     return ReactHtmlParser(data.data.butterPage.paragraph_one)
  //   }
  // }
  // function swapDefaultText2() {
  //   if (data.data.butterPage.paragraph_two) {
  //     console.log("paragraph_two =" + data.data.butterPage.paragraph_two)
  //     return ReactHtmlParser(data.data.butterPage.paragraph_two)
  //   } else if (data.data.default_text_block) {
  //     console.log("default text =" + data.data.butterPage.default_text_block)
  //     return ReactHtmlParser(data.data.default_text_block)
  //   } else {
  //     console.log("attempting to return default text")
  //     return <ProfessionDefaultText />
  //   }
  // }
  useEffect(() => {
    if (data?.data?.butterPage?.industry_page_hero) {
      setIndustryPageHero(data?.data?.butterPage?.industry_page_hero)
    }
    if (data?.data?.butterPage?.industry_page_body) {
      setIndustryPageBody(data?.data?.butterPage?.industry_page_body)
    }
  }, [])

  useEffect(() => {
    // Description: "Insurance for Delivery Businesses & Commercial Couriers"
    // hero_headline: null
    // hero_image: null
    // hero_paragraph: null
    // image: ""
    // thumbnail: "https://cdn.buttercms.com/FpUEP6yRSciKSpwQCUBY"
    // title: "Insurance for Delivery Businesses & Commercial Couriers | Insurance321"
    const heroData = {}
    industryPageHero.forEach(element => {
      if (element?.fields) {
        for (const key in element?.fields) {
          if (Object.hasOwnProperty.call(element?.fields, key)) {
            const data = element?.fields[key]
            if (!heroData[key]) {
              heroData[key] = data
            }
          }
        }
      }
    })
    setPageHero(heroData)
  }, [industryPageHero])

  useEffect(() => {
    // recommended_coverages_header: null
    // section_heading_a: "What kind of insurance do couriers and delivery businesses need?"
    // section_heading_b: null
    // section_heading_c: null
    // section_heading_d: null
    // section_paragraph_a: "At the core of most delivery business insurance plans is some form of auto insurance or vehicle coverage. Depending on the business or individual, that coverage can be in the form of:"
    // section_paragraph_b: null
    // section_paragraph_c: null
    // section_paragraph_d: null
    // section_unordered_list_a: "<ul>\n    <li>Commercial auto insurance</li>\n    <li>Hired & non-owned auto insurance</li>\n    <li>Fleet insurance</li>\n</ul>\n<p>Other coverages that make up an insurance plan for delivery and courier businesses may include:</p>\n<ul>General liability insurance\n    <li>Inland marine/cargo insurance</li>\n    <li>Bailees coverage</li>\n   <li> Workers compensation</li>\n   <li>Crime insurance</li>\n   <li>Errors & omissions coverage</li>\n</ul>"
    // section_unordered_list_b: null
    // section_unordered_list_c: null
    // section_unordered_list_d: null
    const bodyData = {}
    industryPageBody.forEach(element => {
      if (element?.fields) {
        for (const key in element?.fields) {
          if (Object.hasOwnProperty.call(element?.fields, key)) {
            const data = element?.fields[key]
            if (!bodyData[key] && key !== "recommended_coverage_box") {
              bodyData[key] = data
            } else if (key === "recommended_coverage_box") {
              if (bodyData[key]?.length) {
                bodyData[key] = [...bodyData[key], ...data]
              } else {
                bodyData[key] = data
              }
            }
          }
        }
      }
    })
    setPageBody(bodyData)
  }, [industryPageBody])

  // return <>"Amir Ali"</>
  return (
    <div id="profession_page">
      <Helmet>
        <title>{pageHero?.title}</title>
        <meta name="description" content={pageHero?.Description}></meta>
        <Session321 />
      </Helmet>
      <div id="media_hero_bg">
        <ProfessionHerov4
          heroHeadline={ReactHtmlParser(pageHero?.hero_headline)}
          heroSubhead={ReactHtmlParser(
            `<p class='hero-top-sub-heading'>${pageHero?.hero_paragraph}</p>`
          )}
          bgImage={pageHero?.hero_image}
        />
      </div>
      <SectionForV3
        sectionHeading={ReactHtmlParser(pageBody?.section_heading_a)}
        sectionBody={ReactHtmlParser(pageBody?.section_paragraph_a)}
        sectionList={ReactHtmlParser(pageBody?.section_unordered_list_a)}
      />

      <SectionForV3
        sectionHeading={ReactHtmlParser(pageBody?.section_heading_b)}
        sectionBody={ReactHtmlParser(pageBody?.section_paragraph_b)}
        sectionList={ReactHtmlParser(pageBody?.section_unordered_list_b)}
      />

      <SectionForV3
        sectionHeading={ReactHtmlParser(pageBody?.section_heading_c)}
        sectionBody={ReactHtmlParser(pageBody?.section_paragraph_c)}
        sectionList={ReactHtmlParser(pageBody?.section_unordered_list_c)}
      />

      <SectionForV3
        sectionHeading={ReactHtmlParser(pageBody?.section_heading_d)}
        sectionBody={ReactHtmlParser(pageBody?.section_paragraph_d)}
        sectionList={ReactHtmlParser(pageBody?.section_unordered_list_d)}
      />
      {/* <div id="coverage_recos"> */}
      {pageBody?.recommended_coverage_box?.length > 0 ? (
        <CoverageForV3
          recommendedCoverages={pageBody?.recommended_coverage_box}
          coveragesHeader={pageBody?.recommended_coverages_header}
        />
      ) : (
        ""
      )}
      {/* <RecommendedCoverages
          recommendedCoveragesHeader={ReactHtmlParser(
            pageBody?.recommended_coverages_header
          )}
          reco_one={ReactHtmlParser(data.data.butterPage.reco_one)}
          reco_one_link={ReactHtmlParser(data.data.butterPage.reco_one_link)}
          reco_one_blurb={ReactHtmlParser(data.data.butterPage.reco_one_blurb)}
          reco_two={ReactHtmlParser(data.data.butterPage.reco_two)}
          reco_two_link={ReactHtmlParser(data.data.butterPage.reco_two_link)}
          reco_two_blurb={ReactHtmlParser(data.data.butterPage.reco_two_blurb)}
          reco_three={ReactHtmlParser(data.data.butterPage.reco_three)}
          reco_three_link={ReactHtmlParser(
            data.data.butterPage.reco_three_link
          )}
          reco_three_blurb={ReactHtmlParser(
            data.data.butterPage.reco_three_blurb
          )}
          reco_four={ReactHtmlParser(data.data.butterPage.reco_four)}
          reco_four_link={ReactHtmlParser(data.data.butterPage.reco_four_link)}
          reco_four_blurb={ReactHtmlParser(
            data.data.butterPage.reco_four_blurb
          )}
          reco_five={ReactHtmlParser(data.data.butterPage.reco_five)}
          reco_five_link={ReactHtmlParser(data.data.butterPage.reco_five_link)}
          reco_five_blurb={ReactHtmlParser(
            data.data.butterPage.reco_five_blurb
          )}
          reco_six={ReactHtmlParser(data.data.butterPage.reco_six)}
          reco_six_link={ReactHtmlParser(data.data.butterPage.reco_six_link)}
          reco_six_blurb={ReactHtmlParser(data.data.butterPage.reco_six_blurb)}
        /> */}
      {/* </div> */}
      {/* <div id="profession_paragraph_two">{swapDefaultText2() }</div> */}
      <div id="profession_paragraph_two"></div>
      <Differentiator buttonText="Request a Quote" />
      {/* <Service /> */}
      <Footer />
    </div>
  )
}
export default ProfessionPage

export const query = graphql`
  query($slug: String) {
    butterPage(
      slug: { eq: $slug }
      page_type: { eq: "product_page_01_20_2022" }
    ) {
      industry_page_body {
        fields {
          recommended_coverages_header
          section_heading_a
          section_heading_b
          section_heading_c
          section_heading_d
          section_paragraph_a
          section_paragraph_b
          section_paragraph_c
          section_paragraph_d
          section_unordered_list_a
          section_unordered_list_b
          section_unordered_list_c
          section_unordered_list_d
          recommended_coverage_box {
            recommended_coverage_box_header
            recommended_coverage_box_paragraph
            recommended_coverage_slug
          }
        }
      }
      industry_page_hero {
        fields {
          Description
          hero_headline
          hero_image
          hero_paragraph
          image
          thumbnail
          title
        }
      }
      slug
    }
  }
`
